import { gql } from '@apollo/client';

const GET_APPLICATION_PROPERTY = gql`query applicationProperty($applicationId: UUID!, $propertyName: String) {
    applicationProperty(applicationId: $applicationId, propertyName: $propertyName) {
        propertyValue
    }
}`;

export default GET_APPLICATION_PROPERTY;
